module.exports = __webpack_public_path__ + "static/media/star_007CBA.f1649700.svg";